module.exports = __webpack_public_path__ + "static/img/testimony (53).9eccf264.jpg";